import React, { useState } from "react";
import "./CardChat.css";
import ChatComponent from "../ChatComponent";
import { useChat } from "../../contexts/ChatContext";
import { usePlanPermissions } from "../../hooks/usePlanPermissions";

const CardChat = ({ infoTalents }) => {
  const { setExternalChat } = useChat();
  const { validateMessageSending } = usePlanPermissions();

  const handleOpen = () => {
    const validation = validateMessageSending();

    if (validation.allowed) {
      setExternalChat(infoTalents);
    }
  };

  function getFirstName(fullName) {
    return fullName?.trim()?.split(" ")[0];
  }

  return (
    <>
      <button
        className="buttonChatTalents"
        onClick={handleOpen}
      >{`Iniciar chat com ${getFirstName(infoTalents?.name) || " o talento"}`}</button>
    </>
  );
};

export default CardChat;
